import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { EventService } from 'src/app/service/event.service';
import { GeneralService } from 'src/app/service/general.service';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../../controls/datatable/datatable.component';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';

export class ConfirmOverwriteModalData {
  rows: DataTableRow[];
  all: boolean;

  constructor(rows: DataTableRow[], all: boolean) {
    this.rows = rows;
    this.all = all;
  }
}

@Component({
    selector: 'app-confirm-overwrite',
    templateUrl: './confirm-overwrite.component.html',
    styleUrls: ['./confirm-overwrite.component.css'],
    standalone: false
})
export class ConfirmOverwriteComponent implements OnInit {

  cols: DataTableColumn[] = [];
  rows: DataTableRow[] = [];
  isTest: boolean = false;
  processing: boolean = false;
  height: string = "110px;"
  viewheight: string = "100px;"
  overwriteMessage: string;

  constructor(private modalRef: ModalRef, public modalConfig: ModalConfig<ConfirmOverwriteModalData>,
    public authService: AuthenticationService, public genSrv: GeneralService, public eventService: EventService) {
    this.cols = Array<DataTableColumn>(
      new DataTableColumn('binaryName', 'Name', ColumnType.STRING, true, "100", ColumnSort.ASC),
    );
  }

  ngOnInit(): void {
    this.modalConfig.data.rows.forEach(row => {
      if (row.selected && row.data.binary.isDownloaded) {
        this.rows.push((row.data.binary.isLang) ? new DataTableRow({ binaryName: row.data["componentName"] + " - " + row.data["binaryName"] }, null) :
          new DataTableRow({ binaryName: row.data.binary.displayName }, null));
      }
    });

    switch (this.rows.length){
      case 1:
        this.viewheight = "75px";
        break;
      case 2:
        this.viewheight = "110px";
        break;
      case 3:
        this.viewheight = "150px";
        break;
      case 4:
        this.viewheight = "180px";
        break;
      default:
        this.viewheight = "250px";

    }

    if (this.modalConfig.data.all) {
      this.overwriteMessage = $localize`All of the selected products have been downloaded. Are you sure you want to overwrite them?`
    } else if (this.rows.length == 1) {
      this.overwriteMessage = $localize`The selected product has been downloaded. Are you sure you want to overwrite it?`
    } else {
      this.overwriteMessage = $localize`The ${this.rows.length} products listed below have been downloaded.  Are you sure you want to overwrite them?`;
    }

  }

  onClose(): void {
    this.modalRef.close(false);
  }

  onSubmit(): void {
    this.modalRef.close(true);
  }
}
